var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackButtonBottomRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "171px",
    height: "115px",
    viewBox: "0 0 171 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FeedbackButtonBottomRight") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5317616,33.3328865 C30.4910159,30.7459462 35.6712911,21.3353819 33.1022483,12.3138069 C30.5332055,3.2921371 21.1877471,-1.92422698 12.228587,0.662675387 C3.26936093,3.24958724 -1.91091427,12.6601231 0.658090883,21.6817929 C5.30968758,38.0168796 22.8608269,38 22.8608269,38 L21.5317616,33.3328865 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27545157,19.8206179 C0.230719743,16.8877407 -1.49773848,10.3921309 1.41484319,5.31222597 C4.32742015,0.23232109 10.7780814,-1.50817386 15.8228415,1.42470332 C20.8676015,4.35758051 22.596055,10.8531904 19.6834687,15.9330953 C14.4097737,25.1310525 3.76868158,22.4485244 3.76868158,22.4485244 L5.27545157,19.8206179 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FeedbackButtonBottomRight"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.15,
    fill: "#485bff",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 171,
    height: 115
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(105.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    rx: 27
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    rx: 27
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27545446,31.8099298 C0.230713217,28.8770526 -1.49773748,22.3814427 1.41484608,17.3015378 C4.32742304,12.2216329 10.7781031,10.481138 15.8228632,13.4140152 C20.8676233,16.3468924 22.5960768,22.8425022 19.6834904,27.9224071 C14.4097955,37.1203644 3.76868448,34.4378363 3.76868448,34.4378363 L5.27545446,31.8099298 Z",
    id: "Path",
    fill: "#9D50FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7714062,33.3328865 C34.7306605,30.7459462 39.9109357,21.3353819 37.3418929,12.3138069 C34.77285,3.2921371 25.4273917,-1.92422698 16.4682316,0.662675387 C7.50900553,3.24958724 2.32873032,12.6601231 4.89773548,21.6817929 C9.54933218,38.0168796 27.1004715,38 27.1004715,38 L25.7714062,33.3328865 Z",
    id: "Path",
    fill: "#485bff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(4.239645, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.239645, 5.686925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27545446,26.1230043 C0.230713217,23.1901271 -1.49773748,16.6945173 1.41484608,11.6146124 C4.32742304,6.53470753 10.7781031,4.79421258 15.8228632,7.72708977 C20.8676233,10.659967 22.5960768,17.1555768 19.6834904,22.2354817 C14.4097955,31.433439 3.76868448,28.7509109 3.76868448,28.7509109 L5.27545446,26.1230043 Z",
    id: "Path",
    fill: "#9D50FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9780361,5.65241675 C13.7441798,7.18599441 13.2044736,9.24483095 13.2045678,11.216804 C13.2045678,13.188777 13.7441798,15.2476135 14.9780361,16.7811912 C16.1687611,18.2612852 18.1296338,19.410046 21.3412199,19.410046 C24.7272146,19.410046 26.4132902,17.9087102 27.3000243,16.4812464 C27.9239213,15.4769105 28.1474883,14.7429326 28.2275354,14.2484932 C28.2811199,13.9176341 28.5420736,13.6444312 28.8749756,13.6444312 L30.6830996,13.6444312 C31.0159074,13.6444312 31.2896687,13.9162117 31.2613226,14.2502001 C31.1865491,15.1288874 30.8980969,16.4112625 29.854847,18.0904978 C28.4586363,20.3381393 25.8413768,22.4445801 21.3412199,22.4445801 C17.3202158,22.4445801 14.4592363,20.9570894 12.6365155,18.6914304 C10.8567377,16.479255 10.1910278,13.682837 10.1910278,11.216804 C10.1910278,8.75077087 10.8567377,5.95435289 12.6364214,3.74217754 C14.3667583,1.59150841 17.0324228,0.142034758 20.7378527,0.000426328095 C21.0704722,-0.0122807834 21.3412199,0.260741938 21.3412199,0.595934676 L21.3412199,2.41665512 C21.3412199,2.75183838 21.0710372,3.02183605 20.7385119,3.0375208 C17.8812051,3.17228256 16.0923867,4.26724677 14.9780361,5.65241675 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000116, 6.302386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9779202,-0.649969694 C13.7440639,0.883607967 13.2043577,2.94244451 13.2044519,4.91441752 C13.2044519,6.88639052 13.7440639,8.94522707 14.9779202,10.4788047 C16.1686452,11.9588987 18.1295179,13.1076595 21.341104,13.1076595 C24.7270987,13.1076595 26.4131743,11.6063238 27.2999084,10.17886 C28.2673489,8.62148021 28.2721517,7.71415452 28.2721517,7.34204478 L31.2855975,7.34204478 C31.2855975,8.18374867 31.1704238,9.67038588 29.8547311,11.7881114 C28.4585204,14.0357528 25.8412609,16.1421936 21.341104,16.1421936 C17.3200999,16.1421936 14.4591204,14.6547029 12.6363996,12.3890439 C10.8566218,10.1768686 10.1909119,7.3804506 10.1909119,4.91441752 C10.1909119,2.44838443 10.8566218,-0.348033553 12.6363055,-2.5602089 C14.4591204,-4.82586791 17.3200999,-6.31335858 21.341104,-6.31335858 L21.341104,-3.2788245 C18.1295179,-3.2788245 16.1686452,-2.13006369 14.9779202,-0.649969694 Z",
    id: "Path",
    fill: "#FFC5F6",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.1897754,7.57536306 C32.1897754,8.91605815 31.1104573,10.0029903 29.7789435,10.0029903 C28.4475238,10.0029903 27.3681115,8.91605815 27.3681115,7.57536306 C27.3681115,6.23466797 28.4475238,5.1477358 29.7789435,5.1477358 C31.1104573,5.1477358 32.1897754,6.23466797 32.1897754,7.57536306 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackButtonBottomRight);
export default __webpack_public_path__ + "static/media/FeedbackButtonBottomRight.376e24354ad1dfa78292b83fa238f56a.svg";
export { ForwardRef as ReactComponent };